// File Metadata:
// Filename: CrewManagement.js
// Version: 1.00
// Created: 2025-03-28 19:41:52
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useState, useEffect } from 'react'
import { 
    useGetCrewsQuery, 
    useAddCrewMutation,
    useUpdateCrewMutation,
    useDeleteCrewMutation 
} from '../../../api/crewsApiSlice'
import { 
    Box, Paper, Typography, Grid, Table, TableBody, 
    TableCell, TableContainer, TableHead, TableRow,
    Chip, IconButton, Menu, MenuItem, Dialog,
    CircularProgress, Button, DialogTitle, DialogContent, 
    DialogActions, TextField, Select, FormControl, InputLabel, Stack
} from '@mui/material'
import { Person, AccessTime, Engineering, Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material'
import CrewTable from './CrewTable'
import AddCrewDialog from './dialogs/AddCrewDialog'



const CrewManagement = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const { data: crews = [], isLoading, isError, error } = useGetCrewsQuery()
    const [deleteCrewMutation] = useDeleteCrewMutation()
    const [addCrew] = useAddCrewMutation()

    const handleDeleteCrew = async (crewId) => {
        try {
            await deleteCrewMutation(crewId).unwrap()
        } catch (err) {
            console.error('Failed to delete crew:', err)
        }
    }

    const handleSaveCrew = async (crewData) => {
        try {
            await addCrew(crewData).unwrap()
            setIsDialogOpen(false)
        } catch (err) {
            console.error('Failed to save crew:', err)
        }
    }

    if (isLoading) return <CircularProgress />
    if (isError) return <Typography color="error">{error?.data?.message}</Typography>

    return (
        <>
            <Box sx={{ mb: 2 }}>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => setIsDialogOpen(true)}
                >
                    Add New Crew
                </Button>
            </Box>

            <CrewTable 
                crews={crews} 
                onDelete={handleDeleteCrew}
            />

            <AddCrewDialog 
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                onSave={handleSaveCrew}  // Add this prop
            />
        </>
    )
}

export default CrewManagement
